import Clear from './../layouts/Clear.vue';

export default {
  path: '/positionActivesList',
  component: Clear,
  children: [
    {
      path: '',
      name: 'positionActivesList.index',
      component: () => import('@/views/positionActivesList/index.vue'),
    },
  ],
};
